import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Grid } from '@material-ui/core';

export const DetailsMainContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    // flex-direction: column
    ${media.mobileDevice`
        width: ${({ width }) => (width ? width : '100%')};
    `};
`;
export const RowDiv = styled.span`
    display: inline-flex;
    width: 100%;
    justify-content: space-between;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '16px')};
`;

export const PatientRowDiv = styled.span`
    display: inline-flex;
    width: 100%;
    justify-content: space-between;
    ${media.mobileDevice`
        margin-top: 16px;
    `};
`;
export const RadioRowDiv = styled.span`
    display: inline-flex;
    width: ${({ width }) => (width ? width : '100%')};
    margin-bottom: ${({ marginBottom }) => marginBottom};
`;
export const OptionContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0;
    padding: 0;
    cursor: auto;
    padding: ${({ padding }) => (padding ? padding : '5px 10px')};
    & .template {
        font-size: 14px;
        color: #140f4b;
        font-family: AvenirNextWorld Regular;
    }
`;

export const RequestDeliveryDateView = styled.div`
    display: inline-flex;
    width: 100%;
    align-items: center;
    & p {
        padding: 0;
        margin: 0;
        text-align: center;
        width: 40%;
        color: #202124;
        font-size: 14px;
        font-family: 'AvenirNextWorld Regular';
    }
`;

export const ImageContainer = styled.div`
    display: flex;
    margin-right: ${(props) =>
        props.marginRight ? props.marginRight : 'unset'};
    height: 27px;
    width: 25px;
    align-items: center;
    opacity: 1;
    justify-content: center;
    :active {
        box-shadow: -1px -1px 1px #cfe8fe;
    }
`;

export const OptionAccountContainer = styled.div`
    width: calc(100% - 24px);
`;

export const OuterContainer = styled.div`
    display: ${(props) => (props.display ? props.display : 'flex')};
    flex-direction: ${(props) => (props.isLoadMore ? 'column' : 'row')};
    margin: 0;
    padding-left: 0;
    width: 100%;
    position: relative;
    margin: ${(props) => (props.margin ? props.margin : '0')};
`;
export const AccountFieldTitle = styled.label`
    color: #140f4b;
    font-size: 14px;
    //HCP id slanting
    //font-family: AvenirNextWorld Regular;
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Regular'};
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: ${(props) => (props.width ? props.width : 'auto')};
    margin: ${(props) => (props.margin ? props.margin : '0px')};
    cursor: pointer;
    ${media.mediumDevice`
         max-width: ${(props) => (props.iPadwidth ? props.iPadwidth : '25vw')};
    `}
    ${media.mobileDevice`
        max-width: ${(props) =>
            props.mobileWidth ? props.mobileWidth : 'auto'};
    `}
`;

export const AccountFieldAddress = styled.label`
    color: #140f4b;
    opacity: 0.7;
    font-size: 12px;
    font-family: AvenirNextWorld Regular;
    display: inline-block;
    /* margin-right: 10px; */
    max-width: ${(props) => (props.width ? props.width : 'auto')};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    margin: ${(props) => (props.margin ? props.margin : '0px')};
    ${media.mediumDevice`
         max-width: ${(props) => (props.iPadwidth ? props.iPadwidth : '25vw')};
    `}
    ${media.mobileDevice`
        max-width: ${(props) =>
            props.mobileWidth ? props.mobileWidth : 'auto'};
    `}
`;
export const OptionalLoadMoreView = styled.div`
    background-color: #f5f5f5;
    height: ${({ height }) => (height ? height : '200px')};
    display: flex;
    justify-content: center;
    align-items: center;
    // some space is left after grey message area
    margin: ${({ margin }) => (margin ? margin : '10px 0 0 0')};
    flex-direction: column;
    width: 100%;
    & p {
        color: #4f4f4f;
        font-size: 18px;
        font-family: AvenirNextWorld Regular;
        text-align: center;
        margin: 0 0 10px;
    }
    & button {
        padding: 10px;
        color: #1010eb;
        border: 1px solid #1010eb;
        border-radius: 20px;
        text-align: center;
        padding: 5px 13px;
        font-family: AvenirNextWorld Demi;
        font-size: 15px;
        background: #f5f5f5;
    }
`;

export const SurgeryDateView = styled.div`
    display: inline-flex;
    width: 100%;
    align-items: center;
    & p {
        padding: 0;
        margin: 0;
        text-align: center;
        width: 40%;
        color: #202124;
        font-size: 14px;
        font-family: 'AvenirNextWorld Regular';
    }
`;
export const DatePickerDiv = styled.div`
    border: 2px solid #ebeded;
    border-radius: 6px;
    display: flex;
    align-items: center;
    width: 20vw;
    height: 40px;
    justify-content: space-around;
    ${media.mobileDevice`
        width: 40vw;
        height: 40px;
    `};
`;

export const SurgeryTimeView = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
export const PatientView = styled.div`
    flex-direction: row;
    display: flex;

    ${media.mobileDevice`
    flex-wrap: wrap;
    `};
`;

export const Title = styled.div`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 14px;
    margin-bottom: 8px;

    &:after {
        content: '${(props) => (props.showAstrisk ? '*' : '')}';
        color: red;
        padding-left: 3px;
    }
`;

export const MainContainerItems = styled.div`
    width: ${({ setWidth }) => (setWidth ? '100%' : '47%')};
    display: flex;
    flex-direction: ${({ setFlexDirection }) =>
        setFlexDirection ? 'row' : 'column'};
    margin: ${({ setMargin, setMarginRight }) =>
        setMargin
            ? setMargin
            : setMarginRight
            ? setMarginRight
            : '14px 0 8px 0'};
    margin-bottom: ${({ setMarginBottom }) =>
        setMarginBottom ? '16px' : '0px'};

    ${media.mobileDevice`
        width: 100%;
        margin: ${({ mbMargin }) =>
        mbMargin && mbMargin};
    `}
    @media only screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait) {
        margin: ${({ setMarginIpad }) =>
            setMarginIpad ? '14px 20px 8px 0px' : ''};
    }
    ${media.ipadAir`
          margin: ${({ setMarginIpad }) =>
              setMarginIpad ? '14px 20px 8px 0px' : ''};
    `}
    @media only screen and (min-device-width: 1024px) and (max-device-width: 1024px) and (orientation: portrait) {
        /* For ipadPro landscape layouts only */
        margin: ${({ setMarginIpad }) =>
            setMarginIpad ? '14px 30px 8px 0px' : ''};
    }
`;
export const Subtitle = styled.div`
    font-size: 16px;
    font-family: AvenirNextWorld Regular;
`;
export const SurgeryDateErrorDiv = styled.div`
    margin: 10px 5px 10px 0;
`;
export const SurgeryDateErrorTitlerDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
export const SurgeryDateRedText = styled.div`
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    color: red;
    margin: ${({ margin }) => (margin ? margin : '0')};
    ${media.mobileDevice`
        font-size: ${({ mbFontSize }) => (mbFontSize ? mbFontSize : '13px')};
    `}
`;

export const CaseCoverageDiv = styled.div`
    max-width: 462px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${media.mediumDevice`
       max-width: 35vw;
    `}
    ${media.smalDevice`
       max-width: 37vw;
    `}

    ${media.mobileDevice`
       max-width: 71vw;
    `}
`;

export const DatePickerIcon = styled.img.attrs((props) => ({
    src: props.defaultImg,
    alt: props.name,
}))``;

export const StyledDiv = styled.div`
    width: 40px;
`;
export const ImgDiv = styled.div`
    width: 24px;
    align-items: flex-start;
    display: flex;
    justify-content: center;
`;

export const LineSeparator = styled.hr`
    border: 0;
    border-top: 2px solid #e8e8e8;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
    margin: 0px 8px -1px 8px;
`;

export const CreditCardMessageDiv = styled.div`
    margin: 10px 5px 10px 0;
`;
export const CreditCardMessageRedText = styled.div`
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    color: red;
    margin: ${({ margin }) => (margin ? margin : '0')};
    ${media.mobileDevice`
        font-size: ${({ mbFontSize }) => (mbFontSize ? mbFontSize : '13px')};
    `}
`;

export const ContactMessageRedText = styled.div`
    display: flex;
    justify-content: flex-start;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    color: red;
    margin: ${({ margin }) => (margin ? margin : '0')};
    ${media.mobileDevice`
        font-size: ${({ mbFontSize }) => (mbFontSize ? mbFontSize : '13px')};
        margin: ${({ marginMob }) => (marginMob ? marginMob : '0')}
    `}
`;

export const DropDownStyles = {
    'text-overflow': 'unset',
};

export const SelectedCurrentLocation = styled.div`
    width: 360px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: ${({ whiteSpace }) => (whiteSpace ? whiteSpace : 'nowrap')};
    ${media.mediumDevice`
       width: 300px;
    `}
    ${media.smalDevice`
       width: 240px;
    `}
    ${media.mobileDevice`
       width: 240px;
    `}
    ${media.exSmallDevice`
       width: 210px;
    `}
`;

export const SelectedCurrentLoc = styled.div`
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: ${({ whiteSpace }) => (whiteSpace ? whiteSpace : 'nowrap')};
    ${media.mediumDevice`
        width: 260px;
    `}
    ${media.mobileDevice`
        width: 240px;
    `}
`;

export const AdditionalGridContainer = styled(Grid)``;

export const AdditionalInputs = styled(Grid)`
    padding-right: 20px;
    ${media.mobileDevice`
        padding-right:0;
    `}
`;

export const AdditionalResults = styled(Grid)`
    padding: 10px;
    ${media.mobileDevice`
        padding-right:0;
    `}
`;
export const ResultGridContainer = styled(Grid)`
    padding: 10px 15px 0;
    box-shadow: 0px 0px 6px #00000029;
    &:nth-child(odd) {
        background-color: #f5f5f5;
    }
    &:nth-child(even) {
        background-color: #fff;
    }
`;
export const DetailContainer = styled(Grid)``;
export const AddressContainer = styled(Grid)``;
export const TabContainer = styled(Grid)`
    height: 230px;
    overflow-y: scroll;
    font-size: 14px;
    font-family: AvenirNextWorld Regular;
`;
export const MainContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const SearchOptionBox = styled(Grid)`
    padding: 10px 0;
    &.lookupBtn {
        padding: 45px 0 0 10px;
    }
    ${media.mobileDevice`
        padding: 10px 0 !important;
    `}
`;

export const ContactNumberContainer = styled.div`
    position: relative;
`;
